/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

// 邮箱
export function isEmail(email) {
  return /^[A-Za-z0-9\u4e00-\u9fa5\.\-\_]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(
    email
  )
}
// 密码
export function isPsw(str) {
  return /^(?=.*([a-zA-Z].*))(?=.*[0-9].*)[a-zA-Z0-9-*/+._~!@#$%^&*()]{8,20}$/.test(
    str
  )
}
export default {
  isExternal, isEmail, isPsw
}
